import { useEffect } from 'react';
import { VehicleType } from '../common/CommonTypes';
import { useNavigate } from 'react-router';
import { RoutePaths } from '../../Constants/Common';
import { useAppSelector } from 'state/hooks';
import { selectedVehicle } from 'state/selectors/vehicles';

export const useSelectedVehicle = (): VehicleType => {
    const vehicle = useAppSelector(selectedVehicle);
    const navigate = useNavigate();

    useEffect(() => {
        if (vehicle === undefined) {
            navigate(RoutePaths.Home);
        }
    }, []);

    return vehicle;
};
